import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import styles from "./style.module.css";
import trash from "../../../../../../../assets/images/trash-icons/trash-03.svg";
import { useTheme } from "../../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import { updateDelete } from "../../../../../../../store/slices/infoSlice";
import { updateManageProjectsData } from "../../../../../../../store/slices/profile/manageProjectsSlice";
import useManageProjects from "../../../../../../../hooks/useManageProjects";

const DeleteConfirmation = () => {
  const { theme, darkMode } = useTheme();
  const dispatch = useDispatch();
  const { isDeleteOpen, projectId } = useSelector((state) => state.info.delete);

  const {
    data: { applications },
  } = useSelector((state) => state.manageProjects);

  const { handleRemoveApplication } = useManageProjects();

  const handleClose = () => {
    dispatch(updateDelete({ isDeleteOpen: false }));
  };

  const handleRemove = async () => {
    console.log(projectId, "projectId");
    const updatedApplications = applications.filter(
      (app) => app.project_id !== projectId
    );
    dispatch(updateManageProjectsData({ applications: updatedApplications }));
    handleRemoveApplication(projectId);
    handleClose();
  };

  return (
    <Modal
      open={isDeleteOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        className={styles.delConfirm}
        sx={{
          bgcolor: theme.palette.lightgrey.lightgrey00,
          padding: "40px 0px !important",
          borderRadius: "8px !important",
          width: {
            xs: "320px",
            // sm: "360px",
          },
        }}
      >
        <Box className={styles.content}>
          <Box className={styles.frame}>
            <Box className={styles.icon}>
              <img src={trash} alt="delete" />
            </Box>
            <Box className={styles.text}>
              <Typography
                variant="body1"
                component="h4"
                sx={{
                  color: theme.palette.darkgrey.darkgrey600,
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                Do you want to remove this Application?
              </Typography>
            </Box>
          </Box>
          <Box className={styles.buttons}>
            <Button
              variant="text"
              onClick={handleClose}
              sx={{
                textTransform: "capitalize",
                color: theme.palette.darkgrey.darkgrey300,
                bgcolor: darkMode
                  ? "#3D3D3D"
                  : theme.palette.lightgrey.lightgrey500,
                padding: "8px",
                boxShadow: "none",
                fontSize: "16px",
                width: "120px",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                textTransform: "capitalize",
                color: "#FFF",
                bgcolor: theme.palette.danger.red500,
                padding: "8px",
                width: "120px",
                fontSize: "16px",
              }}
              onClick={handleRemove}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
export default DeleteConfirmation;
